/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_4_Accept_DescInputs */

const en_privacy_section_4_accept_desc = /** @type {(inputs: Privacy_Section_4_Accept_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Analytics, Google Tag Manager and Meta Pixel scripts may load (depending on which categories you accepted) to collect anonymous usage data`)
};

const lv_privacy_section_4_accept_desc = /** @type {(inputs: Privacy_Section_4_Accept_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Analytics, Google Tag Manager un Meta Pixel skripti var tikt ielādēti (atkarībā no kategorijām, kurām piekritāt), lai apkopotu anonīmus lietošanas datus`)
};

/**
* | output |
* | --- |
* | "Google Analytics, Google Tag Manager and Meta Pixel scripts may load (depending on which categories you accepted) to collect anonymous usage data" |
*
* @param {Privacy_Section_4_Accept_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_4_accept_desc = /** @type {((inputs?: Privacy_Section_4_Accept_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_4_Accept_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_4_accept_desc(inputs)
	return en_privacy_section_4_accept_desc(inputs)
});